import {ChangeDetectionStrategy, ChangeDetectorRef, Component, inject} from '@angular/core';
import {FormsModule} from '@angular/forms';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {BicButtonComponent, BicPopupComponent} from '@buildinginformationcloud/bic-ui-components';
import {SourceLinkControllerService, SourceLinkView} from '../../../../api';
import {NotificationsService} from '../../../../services/notifications/notifications.service';

export interface UnlinkSourceFolderDialogData {
  projectId: number;
  link: SourceLinkView;
  /** Ohne PROJECT_FILE_DELETE gibt es nur „Dateien behalten“. */
  canDelete: boolean;
}

/**
 * Verknüpfung lösen (BIC-Frontend#2720): Dateien als normale planBIC-Dateien behalten oder den Ordner samt
 * Inhalt in den Papierkorb legen. Schließt mit {@code true}, wenn gelöst wurde.
 */
@Component({
  selector: 'app-unlink-source-folder-dialog',
  templateUrl: './unlink-source-folder-dialog.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [BicPopupComponent, BicButtonComponent, FormsModule]
})
export class UnlinkSourceFolderDialogComponent {
  readonly data = inject<UnlinkSourceFolderDialogData>(MAT_DIALOG_DATA);
  private readonly dialogRef = inject<MatDialogRef<UnlinkSourceFolderDialogComponent, boolean>>(MatDialogRef);
  private readonly sourceLinks = inject(SourceLinkControllerService);
  private readonly notifications = inject(NotificationsService);
  private readonly cdr = inject(ChangeDetectorRef);

  mode: 'KEEP_FILES' | 'TRASH_FILES' = 'KEEP_FILES';
  busy = false;

  unlink(): void {
    this.busy = true;
    this.sourceLinks.deleteSourceLink(this.data.projectId, this.data.link.id!, this.mode).subscribe({
      next: () => {
        this.notifications.showSuccessMessage(this.mode === 'KEEP_FILES'
          ? 'Verknüpfung gelöst. Die Dateien bleiben in planBIC und sind wieder bearbeitbar.'
          : 'Verknüpfung gelöst. Der Ordner liegt im Papierkorb.');
        this.dialogRef.close(true);
      },
      error: err => {
        this.busy = false;
        this.notifications.showErrorMessage(err?.error?.message ?? 'Die Verknüpfung konnte nicht gelöst werden.');
        this.cdr.markForCheck();
      }
    });
  }

  close(): void {
    this.dialogRef.close(false);
  }
}
